export function getFileExtension(fileName: string) {
  const lastDotIndex = fileName.lastIndexOf('.')

  if (lastDotIndex < 0) {
    return ''
  }

  return fileName.slice(lastDotIndex).toLowerCase()
}

export function stripFileExtension(fileName: string) {
  const lastDotIndex = fileName.lastIndexOf('.')

  if (lastDotIndex < 0) {
    return fileName.trim()
  }

  return fileName.slice(0, lastDotIndex).trim()
}

export function getFileTitle(fileName: string, fallbackTitle: string) {
  return stripFileExtension(fileName) || fileName || fallbackTitle
}

export function getFiniteNumber(value: unknown, fallback = 0) {
  return typeof value === 'number' && Number.isFinite(value) ? value : fallback
}

export function normalizeResourceType(type: string) {
  return type.toLowerCase().trim().replace(/-node$/, '')
}

export function matchesMimeType(fileType: string, accept: string) {
  const normalizedAccept = accept.toLowerCase().trim()
  const normalizedFileType = fileType.toLowerCase().trim()

  if (!normalizedAccept) {
    return false
  }

  if (normalizedAccept.endsWith('/*')) {
    return normalizedFileType.startsWith(normalizedAccept.slice(0, -1))
  }

  return normalizedFileType === normalizedAccept
}